import { styled } from '@mui/material/styles';

/** 이미지 크게보기 모달 "본문" 영역 styled */

/**
 * 공통 Modal 의 min-width(688px) 는 expand 에서도 살아 있어 모바일에서 모달이
 * 화면 밖으로 잘린다(닫기 X 버튼까지 화면 밖). 확대 뷰어에서만 해제.
 */
export const zoomModalSx = {
  '& .modal-inner': { minWidth: 0 },
};

/** 다크 배경 뷰어 컨테이너 */
export const ZoomViewerBody = styled('div')`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 60vh;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  /* 터치 pan/핀치를 직접 처리 — 브라우저 기본 제스처(스와이프 뒤로가기 포함) 차단 */
  touch-action: none;
  overscroll-behavior: none;
`;

/** 확대 대상 이미지 — max-width/height none 으로 원본 픽셀 그대로 확대 가능 */
export const ZoomImage = styled('img')`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(1);
  transition: transform 0.25s ease;
  max-width: none;
  max-height: none;
  cursor: grab;
  user-select: none;

  touch-action: none;
  -webkit-user-drag: none;

  &.dragging {
    cursor: grabbing;
  }

  /* 터치 제스처 중에는 손가락을 그대로 따라오도록 트랜지션 해제 */
  &.gesturing {
    transition: none;
  }
`;

/** 하단 줌 버튼 캡슐 — 모바일에서는 숨김(레거시 동일) */
export const ZoomButtonBar = styled('div')`
  position: fixed;
  left: 50%;
  bottom: 30px;
  transform: translateX(-50%);
  z-index: 10;

  ul {
    display: flex;
    gap: 10px;
    padding: 4px 12px;
    margin: 0;
    list-style: none;
    border-radius: 50px;
    background: rgba(255, 255, 255, 0.8);
    box-shadow: 5px 5px 20px 1px rgba(0, 0, 0, 0.5);
  }

  button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    border: 0;
    border-radius: 50%;
    background: transparent;
    color: var(--dk-text-strong, #666);
    cursor: pointer;

    &:hover {
      color: var(--dk-text, #000);
    }

    &:disabled {
      color: var(--dk-text-dim, #ccc);
      cursor: default;
    }

    svg {
      display: block;
      width: 24px;
      height: 24px;
    }
  }

  @media (max-width: 768px) {
    display: none;
  }
`;
